// Lógica principal de la landing page y carga dinámica de la programación
// js/app.js

document.addEventListener("DOMContentLoaded", () => {
    // Inicializar navegación móvil
    initMobileNav();

    // Cargar Catálogo de Obras y Talleres
    cargarCatalogo();

    // Inicializar Carrusel de Patrocinadores
    initSponsorsCarousel();

    // Cargar versión histórica por defecto
    setTimeout(() => {
        mostrarHistorico(2025);
    }, 100);
});

// 1. Navegación Móvil
function initMobileNav() {
    const menuToggle = document.getElementById("menuToggle");
    const navMenu = document.getElementById("navMenu");

    if (menuToggle && navMenu) {
        menuToggle.addEventListener("click", () => {
            navMenu.classList.toggle("active");
            // Animación del botón hamburguesa
            const spans = menuToggle.querySelectorAll("span");
            spans[0].style.transform = navMenu.classList.contains("active") ? "rotate(45deg) translate(5px, 6px)" : "none";
            spans[1].style.opacity = navMenu.classList.contains("active") ? "0" : "1";
            spans[2].style.transform = navMenu.classList.contains("active") ? "rotate(-45deg) translate(5px, -6px)" : "none";
        });

        // Cerrar menú al hacer clic en un enlace
        const navLinks = navMenu.querySelectorAll(".nav-link, .nav-btn");
        navLinks.forEach(link => {
            link.addEventListener("click", () => {
                navMenu.classList.remove("active");
                const spans = menuToggle.querySelectorAll("span");
                spans.forEach(s => s.style.transform = "none");
                spans[1].style.opacity = "1";
            });
        });
    }
}

// Desplazamiento Suave
function scrollToSection(id) {
    const el = document.getElementById(id);
    if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
    }
}

// 2. Cargar Catálogo (Obras y Talleres)
const BACKEND_API_URL = 'api/';

// Obras y Talleres por defecto (Fallback si no hay base de datos conectada o da error)
const SAMPLE_SHOWS = [
    {
        id: 1,
        titulo: "Contame la de Troya",
        descripcion: "Una divertida e histórica adaptación teatral con marionetas gigantes sobre el clásico de Homero. Fomenta el heroísmo positivo, el ingenio y el trabajo en equipo.",
        imagen_url: "img/2025/CONTAME LA DE TROYA.webp",
        categoria: "obra",
        duracion_minutos: 60,
        grupo_artista: "Títeres del Viento (Argentina)",
        recomendacion_edad: "Todo Público",
        funciones: [
            { id: 101, fecha_hora: "2026-10-23 15:00:00", lugar: "Teatro Guillermo Valencia", distribucion: "numerada" },
            { id: 102, fecha_hora: "2026-10-24 17:00:00", lugar: "Teatro Guillermo Valencia", distribucion: "numerada" }
        ]
    },
    {
        id: 2,
        titulo: "La Ratoncita Presumida",
        descripcion: "Una hermosa fábula clásica que enseña a los niños la importancia de la humildad, el respeto mutuo y el valor del amor real sobre las apariencias superficiales.",
        imagen_url: "img/2025/La Ratoncita Presumida.webp",
        categoria: "obra",
        duracion_minutos: 45,
        grupo_artista: "Teatro Hilos Mágicos (Colombia)",
        recomendacion_edad: "Infantil (NNA)",
        funciones: [
            { id: 201, fecha_hora: "2026-10-24 11:00:00", lugar: "Teatro Guillermo Valencia", distribucion: "numerada" },
            { id: 202, fecha_hora: "2026-10-25 15:00:00", lugar: "Parque Caldas (Aire Libre)", distribucion: "general" }
        ]
    },
    {
        id: 3,
        titulo: "Cocorocó, ¡Qué Aventura!",
        descripcion: "El pollito Cocorocó sale del cascarón y se enfrenta al gran reto de encontrar su voz en una granja llena de ruidos extraños. Aventura musical e interactiva.",
        imagen_url: "img/2025/Cocoroco, que aventura.webp",
        categoria: "obra",
        duracion_minutos: 50,
        grupo_artista: "Marionetas de Praga (Rep. Checa)",
        recomendacion_edad: "Primera Infancia",
        funciones: [
            { id: 301, fecha_hora: "2026-10-25 10:00:00", lugar: "Teatro Guillermo Valencia", distribucion: "numerada" }
        ]
    },
    {
        id: 4,
        titulo: "Taller de Títeres de Guante: Crea tu Personaje",
        descripcion: "Aprende a confeccionar un títere de guante de forma sencilla con materiales reciclables y dale vida con tu propia voz. Inscripción abierta.",
        imagen_url: "img/2026/Payasiteres.webp",
        categoria: "taller",
        duracion_minutos: 120,
        grupo_artista: "Talleristas Popayán",
        recomendacion_edad: "Niños de 6 a 12 años",
        funciones: [
            { id: 401, fecha_hora: "2026-10-26 09:00:00", lugar: "Casa de la Cultura", distribucion: "general" }
        ]
    },
    {
        id: 5,
        titulo: "Manipulación y Voz: Dándole vida a la Madera",
        descripcion: "Taller avanzado para jóvenes y adultos enfocado en la manipulación y dramaturgia corporal para títeres de hilos y marionetas clásicas.",
        imagen_url: "img/2025/Sherezada, titeres para adultos.webp",
        categoria: "taller",
        duracion_minutos: 180,
        grupo_artista: "Maestro Alberto Rossi (Italia)",
        recomendacion_edad: "Jóvenes y Adultos",
        funciones: [
            { id: 501, fecha_hora: "2026-10-27 14:00:00", lugar: "Auditorio FUP", distribucion: "general" }
        ]
    }
];

// Constantes y formateadores de fechas para funciones
const DIAS_SEMANA_ABR = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const DIAS_SEMANA_FULL = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const MESES_ABR = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const MESES_FULL = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

function parsearFechaHora(str) {
    if (!str) return null;
    if (typeof str === 'string') {
        const parts = str.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?/);
        if (parts) {
            const year = parseInt(parts[1], 10);
            const month = parseInt(parts[2], 10) - 1;
            const day = parseInt(parts[3], 10);
            const hour = parts[4] !== undefined ? parseInt(parts[4], 10) : 0;
            const minute = parts[5] !== undefined ? parseInt(parts[5], 10) : 0;
            return new Date(year, month, day, hour, minute);
        }
    }
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
}

function formatearHora12h(date) {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minStr = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minStr} ${ampm}`;
}

function formatearFechaCorta(date) {
    const diaSem = DIAS_SEMANA_ABR[date.getDay()];
    const diaNum = date.getDate();
    const mes = MESES_ABR[date.getMonth()];
    return `${diaSem} ${diaNum} ${mes}`;
}

function formatearFechaLarga(date) {
    const diaSem = DIAS_SEMANA_FULL[date.getDay()];
    const diaNum = date.getDate();
    const mes = MESES_FULL[date.getMonth()];
    return `${diaSem} ${diaNum} de ${mes}`;
}

// Genera la insignia sobre la imagen de la tarjeta mostrando únicamente la cantidad de funciones
function renderizarBadgeImagenFecha(funciones) {
    if (!funciones || funciones.length === 0) {
        return '';
    }

    const cant = funciones.length;
    const texto = cant === 1 ? '1 Función' : `${cant} Funciones`;

    return `
        <span class="show-card-date-badge" title="${cant === 1 ? '1 función programada' : `${cant} funciones programadas`}">
            <i class="fa-solid fa-calendar-check"></i>
            <span>${texto}</span>
        </span>
    `;
}

// Genera el bloque estructurado de días y horas de las funciones en el cuerpo de la tarjeta
function renderizarEtiquetaFunciones(funciones) {
    if (!funciones || funciones.length === 0) {
        return `
            <div class="show-card-schedule-badge pending">
                <div class="schedule-badge-pending">
                    <i class="fa-regular fa-calendar-check"></i>
                    <span>Próximamente · Horarios por confirmar</span>
                </div>
            </div>
        `;
    }

    const itemsHTML = funciones.map(f => {
        const d = parsearFechaHora(f.fecha_hora);
        if (!d) return '';
        const diaLargo = formatearFechaLarga(d);
        const diaCorto = formatearFechaCorta(d);
        const horaStr = formatearHora12h(d);
        const lugarStr = f.lugar ? `<span class="schedule-chip-venue"><i class="fa-solid fa-location-dot"></i> ${escapeHtml(f.lugar)}</span>` : '';

        return `
            <div class="schedule-chip">
                <span class="schedule-chip-date" title="${diaLargo}">
                    <i class="fa-regular fa-calendar"></i>
                    <strong>${diaCorto}</strong>
                </span>
                <span class="schedule-chip-time">
                    <i class="fa-regular fa-clock"></i>
                    ${horaStr}
                </span>
                ${lugarStr}
            </div>
        `;
    }).join('');

    const labelHeader = funciones.length > 1 ? 'Funciones programadas:' : 'Función programada:';

    return `
        <div class="show-card-schedule-badge">
            <div class="schedule-badge-header">
                <i class="fa-solid fa-calendar-days"></i>
                <span>${labelHeader}</span>
            </div>
            <div class="schedule-badge-list">
                ${itemsHTML}
            </div>
        </div>
    `;
}

async function cargarCatalogo() {
    const obrasGrid = document.getElementById("obrasGrid");
    const talleresGrid = document.getElementById("talleresGrid");

    try {
        const response = await fetch(`${BACKEND_API_URL}shows.php`);
        const result = await response.json();

        if (result.success && result.data.length > 0) {
            renderShows(result.data, obrasGrid, talleresGrid);
        } else {
            // Si la base de datos está vacía, cargar los por defecto
            renderShows(SAMPLE_SHOWS, obrasGrid, talleresGrid);
        }
    } catch (error) {
        console.warn("API de backend no disponible o error. Usando catálogo de demostración local:", error);
        // Fallback visual
        renderShows(SAMPLE_SHOWS, obrasGrid, talleresGrid);
    }
}

function renderShows(data, obrasContainer, talleresContainer) {
    window.listaObrasGlobal = data;
    obrasContainer.innerHTML = '';
    talleresContainer.innerHTML = '';

    let obrasCont = 0;
    let talleresCont = 0;

    data.forEach(show => {
        const funciones = show.funciones || [];
        const badgeImgHTML = renderizarBadgeImagenFecha(funciones);
        const scheduleHTML = renderizarEtiquetaFunciones(funciones);

        const cardHTML = `
            <div class="show-card">
                <div class="show-card-img-container">
                    <img src="${show.imagen_url}" alt="${show.titulo}" class="show-card-img" width="400" height="250" loading="lazy" onerror="this.style.display='none'">
                    ${badgeImgHTML}
                    <span class="show-card-badge">${show.recomendacion_edad}</span>
                </div>
                <div class="show-card-content">
                    <h3 class="show-card-title">${show.titulo}</h3>
                    
                    ${scheduleHTML}

                    <ul class="show-card-meta">
                        <li class="show-card-meta-item">
                            <i class="fa-solid fa-people-group"></i> 
                            Grupo: <strong>${show.grupo_artista || 'Invitado Especial'}</strong>
                        </li>
                        <li class="show-card-meta-item">
                            <i class="fa-regular fa-clock"></i> 
                            Duración: <strong>${show.duracion_minutos} minutos</strong>
                        </li>
                    </ul>
                    <p class="show-card-desc">${show.descripcion}</p>
                    <div class="show-card-footer">
                        <button class="btn-card-secondary" onclick="verDetalleObra(${show.id}, '${escapeHtml(show.titulo)}')">Ver Obra</button>
                        <button class="btn-card-primary" onclick="iniciarReserva(${show.id}, '${escapeHtml(show.titulo)}')">Comprar</button>
                    </div>
                </div>
            </div>
        `;

        if (show.categoria === 'taller') {
            talleresContainer.insertAdjacentHTML('beforeend', cardHTML);
            talleresCont++;
        } else {
            obrasContainer.insertAdjacentHTML('beforeend', cardHTML);
            obrasCont++;
        }
    });

    // Si no hay elementos cargados
    if (obrasCont === 0) {
        obrasContainer.innerHTML = '<p style="grid-column: 1/-1; text-align: center; color: var(--text-muted);">No hay obras programadas.</p>';
    }
    if (talleresCont === 0) {
        talleresContainer.innerHTML = '<p style="grid-column: 1/-1; text-align: center; color: var(--text-muted);">No hay talleres programados.</p>';
    }
}

// Auxiliar para escapar strings HTML
function escapeHtml(text) {
    if (!text) return '';
    return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

// 3. Ver Detalle de la Obra (Modal informativo)
function verDetalleObra(showId, showTitle) {
    if (!window.listaObrasGlobal || window.listaObrasGlobal.length === 0) {
        // Fallback si no está cargado
        iniciarReserva(showId, showTitle);
        return;
    }
    const show = window.listaObrasGlobal.find(item => item.id == showId);
    if (!show) {
        iniciarReserva(showId, showTitle);
        return;
    }

    // Rellenar el modal
    document.getElementById("detailModalTitle").innerText = show.titulo;
    document.getElementById("detailModalImage").src = show.imagen_url || 'img/placeholder.webp';
    document.getElementById("detailModalImage").onerror = function () {
        this.style.display = 'none';
    };
    document.getElementById("detailModalDesc").innerText = show.descripcion;
    document.getElementById("detailModalGrupo").innerHTML = `<i class="fa-solid fa-people-group"></i> Grupo: <strong>${show.grupo_artista || 'Invitado Especial'}</strong>`;
    document.getElementById("detailModalDuracion").innerHTML = `<i class="fa-regular fa-clock"></i> Duración: <strong>${show.duracion_minutos} minutos</strong>`;
    document.getElementById("detailModalEdad").innerHTML = `<i class="fa-solid fa-child"></i> Recomendación: <strong>${show.recomendacion_edad || 'Todo Público'}</strong>`;
    document.getElementById("detailModalCategoria").innerHTML = `<i class="fa-solid fa-tags"></i> Categoría: <strong style="text-transform: capitalize;">${show.categoria}</strong>`;

    // Renderizar funciones en el modal de detalle
    const modalFuncionesContainer = document.getElementById("detailModalFunciones");
    if (modalFuncionesContainer) {
        if (show.funciones && show.funciones.length > 0) {
            const listItems = show.funciones.map(f => {
                const d = parsearFechaHora(f.fecha_hora);
                const diaStr = d ? formatearFechaLarga(d) : f.fecha_hora;
                const horaStr = d ? formatearHora12h(d) : '';
                const lugarStr = f.lugar ? ` · <i class="fa-solid fa-location-dot"></i> ${escapeHtml(f.lugar)}` : '';
                return `
                    <li style="margin-bottom: 0.45rem; color: var(--text-light); font-size: 0.9rem;">
                        <i class="fa-regular fa-calendar-check" style="color: var(--accent-gold);"></i> 
                        <strong>${diaStr}</strong> a las <strong>${horaStr}</strong>${lugarStr}
                    </li>
                `;
            }).join('');
            modalFuncionesContainer.innerHTML = `
                <div class="detail-modal-funciones-title">
                    <i class="fa-solid fa-calendar-days"></i> Días y Horarios de Funciones:
                </div>
                <ul style="list-style: none; padding-left: 0; margin-bottom: 0;">
                    ${listItems}
                </ul>
            `;
            modalFuncionesContainer.style.display = "block";
        } else {
            modalFuncionesContainer.innerHTML = `
                <div class="detail-modal-funciones-title">
                    <i class="fa-solid fa-calendar-days"></i> Funciones:
                </div>
                <p style="color: var(--text-muted); font-size: 0.88rem; margin: 0; font-style: italic;">
                    Horarios de presentación por confirmar próximamente.
                </p>
            `;
            modalFuncionesContainer.style.display = "block";
        }
    }

    const btnAction = document.getElementById("detailModalBtnAction");
    if (show.categoria === 'taller') {
        btnAction.innerHTML = '<i class="fa-solid fa-pen-to-square"></i> Inscribirse en Taller';
    } else {
        btnAction.innerHTML = '<i class="fa-solid fa-ticket"></i> Reservar Entradas';
    }

    btnAction.onclick = function () {
        cerrarModalDetalle();
        iniciarReserva(show.id, show.titulo);
    };

    document.getElementById("showDetailsModal").classList.add("active");
}

function cerrarModalDetalle() {
    document.getElementById("showDetailsModal").classList.remove("active");
}

// 4. Datos Estáticos de las Ediciones Anteriores (Histórico)
const HISTORIAL_EDICIONES = {
    2025: [
        {
            titulo: "Contame la de troya",
            grupo_artista: "Carbón con patas (Argentina)",
            descripcion: "Bizcocho está por dormir, pero antes exige un cuento. No quiere dragones ni princesas: quiere escuchar la Guerra de Troya. El Titiritero, sorprendido, le advierte que las tragedias no son para niños… pero Bizcocho insiste. Así comienza una versión completamente disparatada de la clásica epopeya, reinventada con humor, música y crítica contemporánea.<br>En esta Troya alternativa, Héctor no defiende murallas: está ocupado construyendo un shopping mall que acepta bitcoins.Paris no roba a Helena, sino que se convierte en un rockero melancólico que canta canciones de Spinetta.Agamenón quiere invadir, pero su ejército está en huelga y exige derechos laborales.Cada personaje clásico se transforma en un arquetipo moderno, absurdo y entrañable, que nos invita a repensar los mitos desde la risa y la ternura.< br /> Pero la obra no se queda en la parodia.A través del juego y la improvisación, el Titiritero y Bizcocho descubren que todos llevamos dentro un caballo de Troya: una historia, un secreto, una posibilidad.Y que, según con qué lo llenemos, puede convertirse en el origen de nuestra tragedia… o de nuestra transformación.< br />\"Contame la de Troya\" es una obra para niñas, niños y adultos que se atreven a reírse de lo solemne, a cuestionar lo heredado, y a imaginar nuevas formas de contar lo antiguo. Porque a veces, para entender el mundo, hay que reinventarlo con títeres, canciones y un poco de desobediencia.",
            imagen_url: "img/2025/CONTAME LA DE TROYA.webp"
        },
        {
            titulo: "La Ratoncita Presumida",
            grupo_artista: "Salud Arte Popayán (Colombia)",
            descripcion: "Es la adaptación del cuento clásico infantil, que relata la historia de una ratoncita que toma una mala decisión a la hora de escoger a sus amigos, este cuento enseña que debemos ser tolerantes y no juzgar a los demás por su apariencia o su forma de hablar.<br>El cuento relata la historia de Luna, una ratoncita que es muy vanidosa que un día saliendo de su casa se encontró una moneda y quería comprarse muchas cosas, para verse más hermosa y refinada, muchos animales vecinos admiran la belleza de nuestra luna, pero ella los rechaza, hasta que……<br>Ven y descubre este maravilloso cuento narrado con títeres en formato pequeño y se testigo de la decisión que toma nuestra ratoncita",
            imagen_url: "img/2025/La Ratoncita Presumida.webp"
        },
        {
            titulo: "Cocoroco, que aventura",
            grupo_artista: "Salud Arte Popayán (Colombia)",
            descripcion: "En el gallinero, Mandamás es el gallo más engreído. Se cree superior, y por eso maltrata a las gallinas sin que nadie lo cuestione. Pero todo cambia cuando aparece una caminante: una figura sabia y solidaria que les muestra a las gallinas que unidas pueden luchar por su libertad y exigir respeto. Así comienza una aventura que transforma el corral en un escenario de resistencia, aprendizaje y esperanza.<br>COCOROCO, ¡Qué aventura! es mucho más que una obra de títeres. Es una puesta en escena Colombo-cubana, fruto de la colaboración entre el Proyecto Géminis de Cuba y la actriz titiritera Cristina Salazar de Colombia. El montaje y la elaboración de los muñecos se realizaron en la Escuela Elisa de La Habana, bajo la dirección del maestro José Luis Quintero, y la obra está basada en el texto de Dora Alonso, reconocida como la señora de las letras en Cuba y ganadora del Premio Nacional de Literatura en 1968.<br>La obra utiliza títeres de manipulación a la vista, donde cada objeto cobra vida en manos de la titiritera, quien no solo controla la escena, sino también la atención del público. Las niñas y niños se convierten en cómplices activos de la historia, ayudando a las gallinas a liberarse del dominio del gallo. Esta interacción directa convierte el espectáculo en una experiencia educativa y emocional, donde el juego y la reflexión se entrelazan.<br>Más allá del humor y la ternura, COCOROCO aborda un tema fundamental: la igualdad de género. A través de personajes animales y situaciones cotidianas, la obra enseña que tanto hombres como mujeres tienen los mismos derechos, deberes y oportunidades. Que no hay lugar para el grito ni la humillación, sino para el respeto, el cariño y la colaboración. Que la unión hace la fuerza, y que desde la infancia podemos sembrar valores que construyan una sociedad más justa y pacífica.<br>Los títeres, como herramienta pedagógica, permiten que los niños y niñas se acerquen a temas complejos de forma accesible y afectiva. Fomentan la lectura, la escucha activa y la expresión emocional. En COCOROCO, cada muñeco es un vehículo de ideas, sentimientos y aprendizajes que se representan oralmente, visualmente y con una carga simbólica que trasciende el escenario.<br>Esta obra es ideal para espacios escolares, comunitarios y culturales que promuevan el diálogo sobre derechos, equidad y convivencia. Porque en el fondo, COCOROCO no solo habla de gallinas y gallos: habla de todas y todos nosotros, y de la posibilidad de transformar el mundo desde el juego, la palabra y la ternura.",
            imagen_url: "img/2025/Cocoroco, que aventura.webp"
        },
        {
            titulo: "Sherezada, titeres para adultos",
            grupo_artista: "La Tortuga Triste (Colombia",
            descripcion: "Inspirada en la legendaria narradora de Las mil y una noches, esta obra presenta una versión libre y audaz de algunos de sus cuentos, adaptados especialmente para el lenguaje de los títeres y dirigidos a un público adulto. Aquí, la palabra se convierte en cuerpo, el mito en juego, y la tradición en provocación.<br>La puesta en escena explora temas como el deseo, el poder, la astucia y la libertad femenina, a través de personajes que desafían los roles clásicos y se reinventan en situaciones absurdas, sensuales y profundamente humanas. Los títeres, lejos de ser infantiles, se transforman en vehículos de crítica, humor y emoción, capaces de interpelar al espectador desde lo visual y lo simbólico.<br>Con una estética cuidada y una dramaturgia que mezcla lo ancestral con lo contemporáneo, Sherezada invita a mirar los cuentos orientales desde una nueva perspectiva: la de quienes aún creen que contar historias puede salvarnos del olvido, del miedo y de la rutina.",
            imagen_url: "img/2025/Sherezada, titeres para adultos.webp"
        },
        {
            titulo: "Kruvicas de Chamamé",
            grupo_artista: "Kossa Nostra (Argentina)",
            descripcion: "Esta obra de títeres rescata el espíritu festivo y comunitario de las regiones fronterizas, donde la música, el humor y la tradición se entrelazan para dar vida a una experiencia escénica vibrante. A través del chamamé —género musical profundamente arraigado en la identidad regional— y de personajes típicos y desopilantes, KRUVIKAS nos invita a reencontrarnos con la fiesta popular como espacio privilegiado de interacción social.<br>La obra está pensada para público general, pero interpela especialmente a jóvenes y adultos, quienes reconocerán en sus escenas ecos de sus propias vivencias, costumbres y memorias colectivas. Con una estética que combina lo rural con lo festivo, y una narrativa que celebra la risa como forma de resistencia, KRUVIKAS de Chamamé se convierte en un homenaje a la cultura viva de nuestros pueblos.<br>Más que un espectáculo, es una celebración de lo que somos: de nuestras músicas, nuestras fiestas, nuestros personajes entrañables y nuestras formas de convivir. Porque en cada chamamé hay una historia, y en cada risa compartida, una comunidad que se reconoce.",
            imagen_url: "img/2025/Kruvicas todo publico.webp"
        },
        {
            titulo: "Kruvicas todo publico",
            grupo_artista: "Kossa Nostra (Argentina)",
            descripcion: "KRUVIKAS es una obra de títeres pensada para público general de todas las edades, aunque su tono atrevido y su mirada crítica conectan especialmente con jóvenes y adultos. Utiliza muñecos creados por el colectivo Kossa Nostra, elaborados con diversas técnicas de manipulación y construcción, que dan vida a historias breves cargadas de humor, música y temas universales: el amor, la solidaridad, la amistad, el juego y la risa.<br>Este espectáculo puede presentarse en casi cualquier espacio físico. Solo se necesita un rincón para armar el teatrillo y un público dispuesto a dejarse llevar por la imaginación y el absurdo. Porque KRUVIKAS no es solo entretenimiento: es una provocación lúdica que se cruza con lo grotesco y lo absurdo de la vida cotidiana, eligiendo el humor como vehículo para expresar lo que importa, siempre desde una mirada propia y comprometida.<br>La obra nace del recuerdo popular, indaga en la memoria colectiva y difunde la cultura de los pueblos del noreste argentino, en la región de la triple frontera con Brasil y Paraguay. En cada escena, KRUVIKAS celebra lo local, lo festivo y lo humano, convirtiendo el títere en un espejo de nuestras contradicciones y nuestras esperanzas.",
            imagen_url: "img/2025/Kruvicas todo publico.webp"
        },
        {
            titulo: "El rapto de la princesa",
            grupo_artista: "Barco Antillano (Cuba)",
            descripcion: "Un juglar aparece en escena con su guitarra al hombro, dispuesto a contar —entre melodías y carcajadas— la historia de un caballero que se lanza a la aventura para rescatar a una princesa raptada en un castillo medieval. Lo que parece un relato clásico de honor y valentía pronto se transforma en una farsa hilarante, donde los malhechores no son tan malvados, los héroes no son tan nobles, y las apariencias se desmoronan al ritmo de la música.<br>A medida que avanza la narración, el caballero enfrenta obstáculos, combate enemigos y descubre que detrás del rescate hay verdades ocultas: identidades que se revelan, propósitos que se cuestionan y roles que se invierten. La obra juega con los códigos del teatro medieval, el absurdo y la sátira, invitando al público a reírse de los estereotipos y a repensar los relatos que nos han contado sobre el poder, el amor y la heroicidad.<br>El Rapto de la Princesa es una propuesta escénica para jóvenes y adultos que disfrutan del humor inteligente, la música en vivo y las historias que se atreven a romper moldes. Porque a veces, para entender lo que somos, hay que mirar los cuentos desde otro lugar.",
            imagen_url: "img/2025/El rapto de la princesa.webp"
        }
    ],
    2024: [
        {
            titulo: "Con un kilo de harina",
            grupo_artista: "FERNAN CARDAMA (Argentina)",
            descripcion: "Premio FETEN 2022  Mejor espectáculo de objetos- Feria Europea de artes escénicas para niños y niñas de Gijón/Xixón- España. Sinopsis: Después de cuarenta y cinco días, con quince años recién cumplidos y sin un peso en el bolsillo, Giuseppe, llegó a la Argentina.<br>Con un kilo de harina se pueden hacer seis pizzas, cien panqueques, ciento veinticuatro sorrentinos y engrudo para cuatro cabezas de títeres. Nosotr@s, con un kilo de harina, te contamos la historia de Giuseppe y su familia; una familia como tantas otras que tuvo que emigrar buscando un futuro mejor. El desafío es, poder contar con un kilo de harina  y algunos utensilios de cocina la historia de tres generaciones de inmigrantes.<br>Intentamos, en esta época “tecno” revalorizar la imaginación y la creatividad partiendo de la idea de que es posible y enriquecedor jugarm trabajar y crear con los que tenemos a nuestro alcance cotidianamente y que no es necesario estar “tecnificado/a” para divertirse. Tomamos en este caso el trabajo hecho en la obra “Con un kilo de harina”. Se trabaja, tal como lo refiere el nombre del espectáculo, con harina y con utensillos de cocina. Es un espectáculo que combina la actuación y la manipulación de objetos.",
            imagen_url: "img/2024/Con un kilo de harina.webp"
        },
        {
            titulo: "La Ratoncita Presumida",
            grupo_artista: "Salud Arte Popayán (Colombia)",
            descripcion: "Es la adaptación del cuento clásico infantil, que relata la historia de una ratoncita que toma una mala decisión a la hora de escoger a sus amigos, este cuento enseña que debemos ser tolerantes y no juzgar a los demás por su apariencia o su forma de hablar.<br>El cuento relata la historia de Luna, una ratoncita que es muy vanidosa que un día saliendo de su casa se encontró una moneda y quería comprarse muchas cosas, para verse más hermosa y refinada, muchos animales vecinos admiran la belleza de nuestra luna, pero ella los rechaza, hasta que……<br>Ven y descubre este maravilloso cuento narrado con títeres en formato pequeño y se testigo de la decisión que toma nuestra ratoncita",
            imagen_url: "img/2025/La Ratoncita Presumida.webp"
        },
        {
            titulo: "Cuidado con el Rey",
            grupo_artista: "ASOCIACION DE ARTE TROTASUEÑOS (Colombia)",
            descripcion: "En el corazón de la selva, la escasez de alimentos amenaza con sumir a sus habitantes en la decadencia. El rey león, desesperado por asegurar la realización de la fiesta anual, encarga al astuto zorro la tarea de conseguir comida a cualquier costo. Es así como el destino los lleva a un encuentro con un conejo ingenioso que, en un intento por salvarse, los conduce a una misteriosa isla donde se rumorea que la comida abunda.<br>Una vez en la isla, el león despliega sus planes para invadir y apropiarse de los recursos, desatando un conflicto que amenaza con destruir la armonía de sus habitantes: el alegre mico y el humilde gusano. Sin embargo, tras el feroz ataque, se produce un giro inesperado cuando tanto agresores como víctimas comprenden que la verdadera riqueza reside en la solidaridad y la amistad sincera.<br>En esta conmovedora historia de superación y redención, se exploran los valores universales de la cooperación y el respeto mutuo mientras los personajes aprenden que solo a través de la unidad y el entendimiento pueden garantizar una convivencia feliz en su amado hogar",
            imagen_url: "img/2024/Cuidado con el Rey.webp"
        },
        {
            titulo: "Títeres a Contramano",
            grupo_artista: "PAYASITERES (Chile)",
            descripcion: "Los títeres se rebelan a sus manipuladores obligándolos a ocupar cualquier objeto o idea para ser transformada en un muñeco, vertiginosamente aparecen personajes e historias que solo son un pretexto para que niños, jóvenes y adultos espectadores, se cautiven con una mentira que parece real, o una realidad que parece mentira<br>Esta compañía se ha presentado en muchos países y en varios festivales de títeres internacionales en toda América Latina.",
            imagen_url: "img/2026/Payasiteres.webp"
        },
        {
            titulo: "Historia de Héroes y Princesas",
            grupo_artista: "Carbón con patas (Argentina)",
            descripcion: "Carbón es un Bufón que sueña con convertirse en Caballero para poder pretender a la Princesa. Sorpresivamente el Conde Manonegra secuestra a laPrincesa y Carbón ofrece ir en su rescate. Lo logrará?",
            imagen_url: "img/2024/Historia de Héroes y Princesas.webp"
        },
        {
            titulo: "Salven a margarita",
            grupo_artista: "MONIGOTES Y MONIFATOS (Mexico)",
            descripcion: "Nuestro amigo Camilo, un títere muy galán, ha llegado a su cita con su amiga margarita, pero en el camino ha escuchado una terrible noticia: Una rata gigante que ha crecido desmedidamente a causa de los desechos tóxicos que un laboratorio ha vertido en las alcantarillas de la ciudad; anda suelta y esta hambrienta, su alimento favorito es la basura orgánica, inorgánica, pero sobre todo la basura reciclada. ¡oh no!, los títeres están hechos de materiales reciclados y ahora tendrán que cuidarse mucho para no ser Devorados",
            imagen_url: "img/2024/SALVEN A MARGARITA.webp"
        },
        {
            titulo: "El pastellini perdido",
            grupo_artista: "MONIGOTES Y MONIFATOS (Mexico)",
            descripcion: "El señor Pepino, está preparando una gran celebración, y aún le falta lo más importante, el pastel.<br>Vizcenzo Italo Calvoni y Roberto Ferrari serán los encargados de tan grata tarea, pero no se imaginan que para llevarla a cabo pasarán tantas peripecias.<br>El Pastellini perdido, es una divertida historia en la que pequeños y grandes se divierten ayudando a los pasteleros con su encargo.<br>Lúdico y dinámico, un espectáculo en el que se representan valores como la amistad, la honestidad, el orden y el respeto",
            imagen_url: "img/2024/El pastellini perdido.webp"
        },
        {
            titulo: "El Guerrero Terrible",
            grupo_artista: "TITIRINDEBA (Colombia)",
            descripcion: "Por error del destino una pequeña e indefensa oruga invade la madriguera de un conejo en medio del bosque y este insignificante acto la hace convertir en el guerrero más terrible que jamás haya tenido la peligrosa selva, los más feroces y valientes animales son vencidos cuando intentan desalojarla. Este guerrero es descubierto tan solo por una intrépida suricata que lo ayuda buscar un lugar donde vivir para que nunca más tenga que asustar a ningún animal.",
            imagen_url: "img/2024/El Guerrero Terrible.webp"
        }
    ],
    2023: [
        {
            titulo: "EL PAJARO AZUL CUENTA",
            grupo_artista: "Crearte de Pereira (Colombia)",
            descripcion: "El pájaro Azul es un cuento maravilloso de tradición oral Afro Colombiana, de la región Guapi-Cauca.<br>Data de una mujer, la buena vieja, muy sobreprotectora y posesiva, quien para evitar que su hijo de 16 años, desarrollara su universo; aprovechando sus podes hechiceros lo convierte en el Pájaro Azul.<br>Más tarde este Pájaro Azul, le ayuda con sus poderes a una niña pre-adolescente, hija de un pescador que, agobiado por la necesidad y escases en la pesca, la negocia con un pescadito por error, a cambio de una canoa llena de pescado.<br>Como la buena vieja agobia a la niña, poniéndole múltiples tareas insólitas, una voz misteriosa la tranquiliza y siempre le da sosiego cumpliendo las tareas para que no perezca por culpa del apego y egoísmo de la madre del príncipe encantado. Se trata del Pájaro Azul, quien confronta a la madre para defender su derecho de volar con la joven hacia los confines del amor y esto deja a la buena vieja en un estado de confrontación que por su dualidad finge sumergirse en la tierra.",
            imagen_url: "img/2023/EL PAJARO AZUL CUENTA.webp"
        },
        {
            titulo: "COCOLOCO Y MARIFLOR",
            grupo_artista: "TEATRO DIADRES (España)",
            descripcion: "Cocoloco tiene de todo un poco y Mariflor es pequeña como una col. Dos personajes que flotan en los cuentos, que viven en los cuentos y en la tradición oral. Sus historias nos traen aromas de cuentos tradicionales, de cuentos populares, de cuentos mil veces contados, pero que también nos traen los versos de García Lorca, los aires de las canciones tradicionales y la dulce poesía de las adivinanzas y trabalenguas.<br>Y todo con el olor de la ropa mojada y la fragancia ancestral de una lavandera con alma de titiritera que, como ha ocurrido siempre, habla cuenta y canta.",
            imagen_url: "img/2023/COCOLOCO Y MARIFLOR.webp"
        },
        {
            titulo: "LAS AVENTURAS DE PELEGRIN",
            grupo_artista: "TEATRO ARBOLE",
            descripcion: "Pelegrín cree que es caballero andante como su antepasado Don Quijote.<br>Sus aventuras le llevan a un reino amenazado por un dragón. Lucha contra él para salvar a la Princesa, pero no le va muy bien. La intervención de un hada le permite tener una alternativa a seguir luchando contra el dragón, realizar tres pruebas. Como no consigue realizarlas vuelve a la pelea contra el dragón, pero, esta vez sale vencedor, aunque, como buen antihéroe que es, ni por esas conseguirá a la Princesa",
            imagen_url: ""
        },
        {
            titulo: "TALLER DE FORMACION VIRTUAL EN TEATRO DE SOMBRAS",
            grupo_artista: "Alessandra Amicarelli (Milán, Italia)",
            descripcion: "Workshop virtual sobre TEATRO DE SOMBRAS a cargo de Alessandra Amicarelli (Milán, Italia) destinado a estudiantes de artes, titiriteros y artistas escénicos.<br>Actividad realizada conjuntamente con la Red Iberoamericana de Festivales de Títeres y Centros Nacionales de UNIMA.<br>Maestra: Alessandra AMICARELLI<br>Titiritera, escenógrafa, directora, performer, formadora, creadora de espectáculos, instalaciones y experiencias en el teatro de animación contemporáneo.",
            imagen_url: "img/2023/TALLER DE FORMACION VIRTUAL EN TEATRO DE SOMBRAS.webp"
        },
        {
            titulo: "AMELIA Y EL VIAJE INESPERADO",
            grupo_artista: "LORMIGA (México)",
            descripcion: "Y tú, ¿Qué llevarías si tuvieras que huir con una sola maleta? Una inminente guerra ha rodeado, desde siempre, las infancias de todos los tiempos, como lo fue en 1937 cuando el barco Mexique llegó a México con 456 niñas y niños que escapaban de la Guerra Civil en España.<br>Para Amelia la guerra no fue real hasta que debía emprender unas “vacaciones secretas” que la llevarían a conquistar sus más grandes miedos. Inspirada en hechos reales. Amelia y el viaje inesperado es una travesía por todo aquello que se deja atrás.",
            imagen_url: "img/2023/AMELIA Y EL VIAJE INESPERADO.webp"
        },
        {
            titulo: "NEPO Y LA BALLENA JOROBADA",
            grupo_artista: "TITIRINDEBA (Colombia)",
            descripcion: "En esta oportunidad el grupo de Títeres de Bellas Artes nos lleva por el fascinante y mágico mundo del pacifico colombiano, para mostrarnos una historia que después de verla la debemos contar. Nepo, un niño de Buenaventura que creyendo que la solución a sus problemas es la de viajar como polizón, descubre a través de su amistad con una ballena Jorobada, todas las posibilidades que le brinda su región para encontrar allí y no en otro lugar, la tan anhelada felicidad.",
            imagen_url: "img/2023/NEPO Y LA BALLENA JOROBADA.webp"
        },
        {
            titulo: "La mona Simona",
            grupo_artista: "LA SONRISA DEL LAGARTO (España)",
            descripcion: "Compañía ganadora de varios reconocimientos en los festivales de títeres de España, República Dominicana.<br>Un espectáculo sencillamente bello, inspirado en valores como la amistad y el amor a la naturaleza. Innovador porque mezcla las técnicas del teatro de sombras chinescas, los títeres y la narración e interpretación. Además, recrea el mundo mágico, por medio de la teatralización de los cuentos universales. Esta mezcla de técnicas y la dificultad que afronta cada una de ellas por separado y en conjunto, generan un espectáculo revelador, moderno, ideal para el disfrute de toda la familia por su creatividad y calidad artística.<br>Colgada de una rama de un milenario Baobab, la mona Simona espera soñolienta la llegada del alba para saludar al astro rey, el Sol. A todos los otros animales que pasan por debajo su árbol les invita a ver el gran espectáculo, y para ahuyentar el sueño y la soledad de la espera, les pide que le cuente un cuento mientras.",
            imagen_url: "img/2023/La mona Simona.webp"
        }
    ],
    2022: [
        {
            titulo: "VALENTINA Y LA SOMBRA DEL DIABLO",
            grupo_artista: "Baúl de la Fantasía de Bogotá (Colombia)",
            descripcion: "Valentina tiene miedos, miedos hechos piedras que no la dejan hablar, miedos que pesan y le impiden vencer a esa sombra que la visita todas las noches.<br>Por fortuna, en el patio trasero de su casa encontrará al místico y viejo abuelo Lázaro, quien la guiará para iluminar la sombra, romper la cadena de silencios y desintegrar sus miedos.<br>Está inscrita en la corriente de obras que buscan compartir con el público temas que son urgentes y necesarios, habla de esos secretos que duelen y son callados, de situaciones de las cuáles es necesario tomar decisiones para poder salir adelante.",
            imagen_url: "img/2022/VALENTINA Y LA SOMBRA DEL DIABLO.webp"
        },
        {
            titulo: "La Ratoncita Presumida",
            grupo_artista: "Salud Arte Popayán (Colombia)",
            descripcion: "Es la adaptación del cuento clásico infantil, que relata la historia de una ratoncita que toma una mala decisión a la hora de escoger a sus amigos, este cuento enseña que debemos ser tolerantes y no juzgar a los demás por su apariencia o su forma de hablar.<br>El cuento relata la historia de Luna, una ratoncita que es muy vanidosa que un día saliendo de su casa se encontró una moneda y quería comprarse muchas cosas, para verse más hermosa y refinada, muchos animales vecinos admiran la belleza de nuestra luna, pero ella los rechaza, hasta que……<br>Ven y descubre este maravilloso cuento narrado con títeres en formato pequeño y se testigo de la decisión que toma nuestra ratoncita",
            imagen_url: "img/2025/La Ratoncita Presumida.webp"
        },
        {
            titulo: "LOS TRES CERDITOS",
            grupo_artista: "Manicomio de muñecos de Medellín (Colombia)",
            descripcion: "Espectáculo de títeres de mesa, hecho con base en el clásico infantil del mismo nombre.<br>Con un montaje sencillo pero a la vez dinámico- la obra cuenta la historia conocida de los tres cerditos que intentan proteger su casa de los embates del lobo, sus soplos desesperados por tumbar el hogar de los tres personajes de esta famosa fábula.<br>La obra, que cuenta con la dramaturgia de Alejandra Barrada, quien también es titiritera, dramaturga, diseñadora y codirectora del Teatro, recibió en el año 2000 el premio “Txantxo de oro” al mejor espectáculo del Festival Internacional de Marionetas de Tolosa, España, y ha sido desde hace varios años una de las obras insigne de Manicomio.<br>“La idea es darle la vuelta a la historia clásica que igual siempre ha tenido modificaciones por quienes la han adaptado, pero esta vez hacerlo nosotros a la manera más íntima de Manicomio.",
            imagen_url: "img/2022/LOS TRES CERDITOS.webp"
        },
        {
            titulo: "OH GLORIA INMARCESIBLE",
            grupo_artista: "La loca Compañía de Armenia (Colombia)",
            descripcion: "Un viaje lúdico por la historia de Colombia. Con títeres, máscaras, actuación y música en vivo se escenifican los acontecimientos más significativos de nuestra historia.<br>Los sucesos de la obra transcurren en el MUSEO DE LA PATRIA. Donde don Joaquín el viejo vigilante pasa su última noche de trabajo rodeado de los héroes y villanos protagonistas de la historia de Colombia.<br>En cuadros aislados se escenifican hechos referentes al descubrimiento, la conquista, la esclavitud, La rebelión de los comuneros, el grito de la independencia y la gran Colombia.",
            imagen_url: "img/2022/OH GLORIA INMARCESIBLE.webp"
        },
        {
            titulo: "FABULARIA, EL GALLO KIKIRIGALLO",
            grupo_artista: "La Carreta Teatro (España)",
            descripcion: "“Prestad atención a este pobre juglar que más de mil historias os viene a contar.<br>Trovador, poeta, cantor; Canto cuentos, cuentos canto y recito versos cuando me levanto”.Así comienza FABULARIA, un espectáculo ágil y participativo, que cuenta con la gracia del Juglar y el ritmo de los Títeres.<br/> Una propuesta de La Carreta Teatro realizada para niños y niñas que recoge algunas de las más bellas fábulas de la historia.<br/>…Cantos cuentos, fábulas con moraleja y corazón, más de mil historias os traigo en este zurrón.",
            imagen_url: "img/2022/FABULARIA, EL GALLO KIKIRIGALLO.webp"
        },
        {
            titulo: "MUNDO BILINA",
            grupo_artista: "Asociación Teatral Compañía Nacional de Fósforos, La Cia Arde la Nona y la Cia Omar Álvarez Títeres",
            descripcion: "Libros de brujería, tarántulas, espejos que reflejan con retraso, una peluca enteramente hecha de lombrices, una muñeca con cerebro de sapo y un globo terráqueo puesto del revés: todas esas cosas guardan Bilina en su cuarto. Cada mañana cuando se levanta piensa una forma de destruir el mundo… Hasta que una noche recibe una visita inesperada que la ayudará a ejecutar con éxito sus complicadísimos planes…<br/>MUNDO BILINA es la adaptación de la novela homónima de Cristian Palacios, finalista del Premio El Barco de Vapor 2008 y publicada en Argentina y México por la editorial SM. Se trata de la primera Co-Producción conjunta de la Compañía Omar Álvarez Títeres, la Compañía Nacional de Fósforos y Arde la Nona",
            imagen_url: "img/2022/MUNDO BILINA.webp"
        }
    ],
    2021: [
        {
            titulo: "MISIÓN IMPOSIBLE",
            grupo_artista: "Punto de Partida (Colombia)",
            descripcion: "Versión libre de la novela infantil Solomán, cuyo autor es Ramón García Domínguez. La obra se inicia con la reunión de la Organización Mundial de Superhéroes, todos acuden al llamado, los superhéroes se desplazan a grandes velocidades a los rascacielos de la ciudad gótica punto de encuentro según las coordenadas del presidente, allí un nuevo súper  héroe será presentado en sociedad, Batman, la Batichica, la mujer maravilla y Superman, serán sorprendidos por un héroe de carne y hueso Súper- Niño, quien pondrá a    prueba los súper poderes de los grandes héroes que van hacer vencidos por la fragilidad, el sentimiento, la inteligencia y la sensibilidad de un niño que a través del poder del amor, la comprensión, la solidaridad, el perdón y la resiliencia serán derrotados.",
            imagen_url: ""
        },
        {
            titulo: "CAPERUCITA ROJA",
            grupo_artista: "Pablo Drigo (Argentina)",
            descripcion: "Amada Caperucita: Al principio sólo quería comerte. Luego conocí lo que es la capa roja esconde y me enamoré. Yo no maté a tu abuelita. Se escapó con el cazador, ellos viven juntos en la otra punta del bosque.<br/>No soy tan malo, no creas todo lo que dicen de mí.Los Lobos podemos cambiar, por vos me hago vegetariano y te prometo ayudar a los chanchitos con su construcción.Te invito a tomar un café mañana y vemos que pasa.<br/>Sinceramente tuyo.< br /> El Lobo Feroz",
            imagen_url: "img/2020/CAPERUCITA ROJA.webp"
        },
        {
            titulo: "LA DUENDECILLA TRAVIESA",
            grupo_artista: "Trotasueños (Colombia)",
            descripcion: "Basada en la obra de Julio Cordero “El hortelano y la jardinera” adaptada y dirigida por Reinel Osorio Torres y con la actuación de Eliecer Paternina, Flor de Lis Agudelo y Maria Alejandra Padilla. La Duendecilla está en temporada de estreno. Relata la historia de dos vecinos que, en lugar de convivir, se confrontan por culpa de una duendecilla y sus travesuras.",
            imagen_url: ""
        },
        {
            titulo: "Cocoroco, que aventura",
            grupo_artista: "Salud Arte Popayán (Colombia)",
            descripcion: "Mandamás es el gallo más fino que tiene el gallinero, y por eso se cree con el derecho de maltratar a las gallinas, pero un día llega una caminante y ayuda a las gallinas a revelarse y que se hagan respetar, porque tanto vale gallo como gallina.<br/>Los niños aprenden con esta obra que tanto hombre como mujer tienen los mismos derechos y las mismas oportunidades.",
            imagen_url: "img/2025/Cocoroco, que aventura.webp"
        },
        {
            titulo: "Sherezada, titeres para adultos",
            grupo_artista: "La Tortuga Triste (Colombia)",
            descripcion: "Inspirada en la legendaria narradora de Las mil y una noches, esta obra presenta una versión libre y audaz de algunos de sus cuentos, adaptados especialmente para el lenguaje de los títeres y dirigidos a un público adulto. Aquí, la palabra se convierte en cuerpo, el mito en juego, y la tradición en provocación.<br>La puesta en escena explora temas como el deseo, el poder, la astucia y la libertad femenina, a través de personajes que desafían los roles clásicos y se reinventan en situaciones absurdas, sensuales y profundamente humanas. Los títeres, lejos de ser infantiles, se transforman en vehículos de crítica, humor y emoción, capaces de interpelar al espectador desde lo visual y lo simbólico.<br>Con una estética cuidada y una dramaturgia que mezcla lo ancestral con lo contemporáneo, Sherezada invita a mirar los cuentos orientales desde una nueva perspectiva: la de quienes aún creen que contar historias puede salvarnos del olvido, del miedo y de la rutina.",
            imagen_url: "img/2025/Sherezada, titeres para adultos.webp"
        }
    ],
    2019: [
        {
            titulo: "SHEREZADA, RELATOS DE LAS 1001 NOCHES",
            grupo_artista: "La Tortuga Triste (Colombia)",
            descripcion: "Inspirada en la legendaria narradora de Las mil y una noches, esta obra presenta una versión libre y audaz de algunos de sus cuentos, adaptados especialmente para el lenguaje de los títeres y dirigidos a un público adulto. Aquí, la palabra se convierte en cuerpo, el mito en juego, y la tradición en provocación.<br>La puesta en escena explora temas como el deseo, el poder, la astucia y la libertad femenina, a través de personajes que desafían los roles clásicos y se reinventan en situaciones absurdas, sensuales y profundamente humanas. Los títeres, lejos de ser infantiles, se transforman en vehículos de crítica, humor y emoción, capaces de interpelar al espectador desde lo visual y lo simbólico.<br>Con una estética cuidada y una dramaturgia que mezcla lo ancestral con lo contemporáneo, Sherezada invita a mirar los cuentos orientales desde una nueva perspectiva: la de quienes aún creen que contar historias puede salvarnos del olvido, del miedo y de la rutina.",
            imagen_url: "img/2019/SHEREZADA, RELATOS DE LAS 1001 NOCHES.webp"
        },
        {
            titulo: "CAPERUCITA ROJA - UNA HISTORIA CONOCIDA PERO DIFERENTE",
            grupo_artista: "Pablo Drigo (Argentina)",
            descripcion: "Amada Caperucita: Al principio sólo quería comerte. Luego conocí lo que es la capa roja esconde y me enamoré. Yo no maté a tu abuelita. Se escapó con el cazador, ellos viven juntos en la otra punta del bosque.<br/>No soy tan malo, no creas todo lo que dicen de mí. Los Lobos podemos cambiar, por vos me hago vegetariano y te prometo ayudar a los chanchitos con su construcción. Te invito a tomar un café mañana y vemos que pasa.<br/>Sinceramente tuyo.<br/>El Lobo Feroz",
            imagen_url: "img/2019/CAPERUCITA ROJA - UNA HISTORIA CONOCIDA PERO DIFERENTE.webp"
        },
        {
            titulo: "EL NUEVO TRAJE DEL EMPERADOR",
            grupo_artista: "TEATRO EL DESGUACE (España)",
            descripcion: "Inspirado en el conocido cuento de Andersen, Desguace Teatro nos presenta El nuevo traje del Emperador, una propuesta de titiritero solista a cargo de Tomás Pombero, bajo la dirección de Ana Santa Cruz.<br/>En el imperio de Tafetán todo está preparado para sus grandes fiestas. Las calles visten sus mejores galas, la lista de ilustres invitados e invitadas que vendrán de lejos está confeccionada, en la cocina de palacio los fogones preparan ricos manjares...En fin, que todo está listo para las fiestas y su acontecimiento central, la Gran Pasarela donde el emperador lucirá su nuevo traje. Pero no, falta lo más importante, aún no han encontrado una tela apropiada para que este sea confeccionado. ¡Y solo quedan tres días! ¿Dará tiempo?",
            imagen_url: "img/2019/EL NUEVO TRAJE DEL EMPERADOR.webp"
        },
        {
            titulo: "NÁUFRAGOS",
            grupo_artista: "TEATRO EL DESGUACE (España)",
            descripcion: "NOMINADO EN LOS PREMIOS ESCENARIOS DE SEVILLA ESPAÑA 2011 INTERPRETACIÓN MASCULINA<br/>Náufragos es un espectáculo de Títeres para adultos de pequeño formato, en el que se recrea todo un universo etílico que comienza por los materiales con los que se han confeccionado los Títeres: corchos, cajas de vino, sacacorchos y ... por supuesto, alguna que otra bebida alcohólica y \"es que cualquiera puede ser o sentirse un náufrago, aunque no se le haya hundido el barco ni esté sólo en una isla desierta\".<br/>Todo esto en un espectáculo sin palabras, basado en la cercanía con el público y en gestos muy minuciosos, recreando el imaginario etílico de la isla desierta que llevamos por dentro. (Revista Artez)",
            imagen_url: "img/2019/NÁUFRAGOS.webp"
        },
        {
            titulo: "TIC TAC EL HÉROE DEL TIEMPO",
            grupo_artista: "OMAR ÁLVAREZ (Argentina)",
            descripcion: "Cada mañana, Tic Tac,  un antiguo  reloj despertador, da cuerda a su entrañable colección de relojes en cuyo interior  se atesoran y resguardan momentos felices.<br/>Repentinamente, se verá amenazado al recibir un tentador obsequio del ambicioso Wifi, un modernismo  teléfono, que detrás de su  inocente apariencia, oculta intereses peligrosos  que  complicarán su existencia.<br/>“Tic Tac, el héroe del tiempo”, es el nuevo  espectáculo sin palabras, del titiritero  Omar Álvarez  ,quien, combina delicados títeres creados a partir de objetos cotidianos, con proyecciones realizadas en stop-motion ( técnica de  animación fotográfica, cuadro por cuadro), proponiendo una romántica  aventura llena de emoción, humor y poesía visual, que cautivará a públicos de todas las edades",
            imagen_url: "img/2019/TIC TAC EL HÉROE DEL TIEMPO.webp"
        },
        {
            titulo: "SOLILUNA",
            grupo_artista: "HILANDO TÍTERES (España)",
            descripcion: "Al principio del todo, cuando sobre la Tierra no había nada de nada, de lo más profundo del mar, surgió una montaña.<br/>La colosal montaña dividía el mundo en dos partes y estaba atravesada por un agujero, un profundo y largo agujero… ¡casi sin fin! A través del cual no se podía ver nada, pero sí se podía escuchar…<br/>La vida surge pronto, y al igual que la amistad y la alegría, los equívocos y los malos entendidos nacen a ambos lados de la montaña. Y todo tiene sus consecuencias…",
            imagen_url: "img/2019/SOLILUNA.webp"
        },
        {
            titulo: "TÍTERES DE CACHI-CACHI PORRA",
            grupo_artista: "BAÚL TEATRO (Mexico)",
            descripcion: "Don Avaricio pretende estafar a Juan y Nicasio comprometiéndolos a pasar la noche en una casa abandonada pero después de muchas jugarretas titiriteras así como varias peleas con chachiporras Don Avaricio es vencido gracias a la astucia de Juan y la lealtad de Nicasio.<br/>Espectáculo que se vale de una anécdota sencilla para recuperar y mostrar juegos tradicionales de títeres de guante o guiñol para titiritero solista, a la usanza de aquellos surgidos en la Comedia del Arte y que viajaron por Europa en manos de hábiles titiriteros y personajes entrañables como Guiñol, Polichinela o Punch y Judy.<br/>El diálogo con los espectadores y la participación de estos aunado al ritmo arrebatado de los muñecos  son elementos claves en este tipo de espectáculos donde se hace un elogio del ingenio del protagonista para resolver cuanto problema deba enfrentar",
            imagen_url: "img/2019/TÍTERES DE CACHI-CACHI PORRA.webp"
        },
        {
            titulo: "PESCADOR",
            grupo_artista: "FUNDACIÓN TORTUGA TRISTE (Colombia)",
            descripcion: "Es la historia de un pescador llamado Jacinto, este pescador tiene algo muy especial pues siempre le ha gustado pescar de noche y hace que la luna y el mar sean sus cómplices y compañeros de grandes aventuras, Jacinto es un Negro que no tiene fortuna solo tiene su bohío, barca y atarraya.<br/>Un día cuando el llega de pescar, para vender en la subienda ve en la playa a una Negra que está cantando y bailando, el queda enamora del movimiento de sus caderas, ella es Lola, una vendedora de mangos, de inmediato Jacinto comienza a enamorarla, regalándole versos y poemas de amor, pues es su manera de enamorar a Lola, pero ella no se convence y le pide otra cosa a cambio de un beso suyo. Ven y descubre con Jacinto que en lo que quiere la negra",
            imagen_url: "img/2019/PESCADOR.webp"
        }
    ],
    2018: [
        {
            titulo: "NIDOS",
            grupo_artista: "TEATRO TELONCILLO (España)",
            descripcion: "Esta obra es apta para niños desde los 6 meses hasta los 5 años.<br/>Los sonidos del bosque envolverán el ambiente y nos cobijaremos al pie de un árbol, donde habitan seres y enseres, telas y arañas, hebras y culebras.<br/>Premio al mejor espectáculo para la primera Infancia, Feria Europea de Artes Escénicas para Niños y Niñas – FETEN 2014 y Finalista de los premios Max 2015.<br/>Vamos a volar, cantar, escuchar, bailar, jugar y vamos a anidar. Los pájaros se adentrarán en las cabezas de los pequeños espectadores y allí harán su particular NIDO. Nuestros pájaros se irán a menudo por las ramas; de día cuando vuelen pintarán el aire, serán artistas cuando canten y por la noche, serán músicos dormidos en las ramas. Nos vamos a cobijar en el árbol, a oler a tomillo, a comer frutos del bosque, a viajar con la cigüeña, con el picapinos hacer agujeros, soñar con el mirlo; pero no todo serán pájaros. Vamos a pasar un rato cargado de juegos, vuelos, sonidos y nidos.",
            imagen_url: "img/2018/NIDOS.webp"
        },
        {
            titulo: "PESCADOR",
            grupo_artista: "FUNDACIÓN TORTUGA TRISTE (Colombia)",
            descripcion: "Es la historia de un pescador llamado Jacinto, este pescador tiene algo muy especial pues siempre le ha gustado pescar de noche y hace que la luna y el mar sean sus cómplices y compañeros de grandes aventuras, Jacinto es un Negro que no tiene fortuna solo tiene su bohío, barca y atarraya.<br/>Un día cuando el llega de pescar, para vender en la subienda ve en la playa a una Negra que está cantando y bailando, el queda enamora del movimiento de sus caderas, ella es Lola, una vendedora de mangos, de inmediato Jacinto comienza a enamorarla, regalándole versos y poemas de amor, pues es su manera de enamorar a Lola, pero ella no se convence y le pide otra cosa a cambio de un beso suyo. Ven y descubre con Jacinto que en lo que quiere la negra",
            imagen_url: "img/2019/PESCADOR.webp"
        },
        {
            titulo: "LA VERDADERA HISTORIA DE CAPERUCITA ROJA",
            grupo_artista: "BUHO TEATRO (España)",
            descripcion: "Caperucita se encuentra con el Lobo en un recodo del camino. El lugar es transitado también por muchos personajes de otros cuentos. Por aquí pasarán Los Tres Cerditos, El Gato con Botas, un Policía Defensor de la Naturaleza y el orden. En medio de esta confusión, los planes del Lobo se verán truncados. ¿ Como acabará esta historia?.",
            imagen_url: "img/2018/LA VERDADERA HISTORIA DE CAPERUCITA ROJA.webp"
        },
        {
            titulo: "SIRENA FISSURA",
            grupo_artista: "COMPAÑÍA ELÁSTIC NOU",
            descripcion: "¿Qué sucede cuando no encuentras ningún zapato de tu talla? O ¿cuando tus gustos no encajan con los del resto? Y ¿cuando no se es suficientemente femenina o se es demasiado afeminado?<br/>Daniela intenta encajar, se esfuerza para ser como el resto, pero no lo consigue. Roc se da cuenta que, si se muestra tal como es, es rechazado por sus compañeros. Y si al descubrirse el uno en el otro exploraran el poder de la diferencia y la amistad y juntos se hicieran más fuertes?<br/>Daniela y Roc nos invitan a cuestionarnos los roles de género a través de un viaje por los mundos fantásticos del teatro de objetos, donde la realidad aparente se transforma en otra cosa.",
            imagen_url: "img/2018/SIRENA FISSURA.webp"
        }
    ],
    2017: [
        {
            titulo: "Divertiteres",
            grupo_artista: "Omar Alvarez (Aargentina)",
            descripcion: "Divertiteres: trabaja firmemente y comprometida en el desarrollo del Arte de los Títeres. Procurando el más alto nivel estético, sus espectáculos han merecido el reconocimiento del público, el medio ,y la crítica especializada, recibiendo más de treinta premios y galardones nacionales e internacionales." + '<br/>' + "La participación de los máximos exponentes de la escena nacional, como&nbsp;Alfredo Alcón&nbsp; y &nbsp;Norma Aleandro&nbsp;, en sus diferentes espectáculos; la creación de varias co-producciones internacionales ; la sostenida actividad de su propia sala teatral en Buenos Aires (Centro Cultural Espacios&nbsp;,Villa Ballester); y el desarrollo de tareas de investigación y formación profesional, a su cargo, definen su innovador perfil artístico." + '<br/>' + "Representando a la cultura argentina en escenarios de todo el mundo, el grupo realiza giras por países como Canadá,&nbsp;EE.UU&nbsp;,Dinamarca, Finlandia, España, Polonia, Israel, Corea, Singapur, Hong Kong, Malasia, Sudáfrica, Brasil, México, Colombia, Japón, China, Rusia, entre otros, interpretando sus trabajos en más de ocho idiomas diferentes, y conquistando públicos de las más diversas culturas.",
            imagen_url: "img/2017/divertiteres.webp"
        },
        {
            titulo: "una de amor",
            grupo_artista: "Artello teatro Alla Scala 1:5 (España)",
            descripcion: "Los animales que habitan en una pequeña villa viven atemorizados por la inquietante presencia de un vecino díscolo, el Gato Rayado. Con la llegada de la Primavera, una joven y osada golondrina consigue lo nunca visto: ante el estupor de toda la vecindad, el Gato Rayado ha sonreido. (Inspirado en “El Gato Manchado y la Golondrina Sinhá”, de Jorge Amado, y en las ilustraciones de Carybé)" + '<br/>' + "''La simplicidad del encuentro del gato manchado con la golondrina es traducida por los españoles en un espectáculo grandioso, sobre todo por la agilidad en la manipulación de los muñecos y la incorporación del lenguaje cinematográfico.'' (K. Henrique, Correio Braziliense)</p>",
            imagen_url: ""
        },
        {
            titulo: "The puppet of my life",
            grupo_artista: "Compañía Trulé de Portugal (Portugal)",
            descripcion: "Teatro Municipal de Popayán, presenta un espectáculo de Robertos con ingredientes poco habituales en esta forma de teatro de marionetas." + '<br/>' + "Basada en la \"Tourada a la portuguesa\", una de las piezas que componen el restringido repertorio tradicional de Robertos, \"Una corrida de los Diablos\" presenta una visión muy propia del enfrentamiento del Hombre con la \"bestia\", venga en forma de animal o diablo, sea el reflejo de sí mismo o una imagen de ojos cerrados." + '<br/>' + "La música, en los espectáculos de Robertos, tiene un papel fundamental para contar la historia.  Juega y dialoga con los muñecos, transporta las emociones en las cuerdas de las violas y de las voces." + '<br/>' + "Tradicionalmente, el pañuelo blanco es exhibido para la asignación de música en la torada a la portuguesa.",
            imagen_url: "img/2017/The puppet of my life.webp"
        },
        {
            titulo: "No toques mis círculos",
            grupo_artista: "Artello Teattro Alla Scala 1:5 (España)",
            descripcion: "Según la leyenda, <em>\"No toques mis círculos\"</em> &nbsp;fueron las ultimas palabras del sabio Arquímedes de&nbsp;Siracusa, antes de morir a manos de un soldado romano, allá por el 212 A.C.<br/> Hace unos meses que Tomas Canalejo, un científico apasionado por su trabajo en la universidad, fue despedido. Ahora se reinventa partiendo de la máxima del profeta: \"si la gente no va a la física, la física tendrá que ir a la gente\". <br/>Así pues estad alerta, porque os lo podéis encontrar con sus fijaciones en cualquier palestra que se ponga a su alcance. Entusiasmo y osadía no le faltan, pero... le bastara con eso?",
            imagen_url: ""
        },
        {
            titulo: "Relatos de Matilda",
            grupo_artista: "Fundación La Tortuga Triste (Colombia)",
            descripcion: "Proyecto ganador de la convocatoria 2017 de Estímulos Culturales de la Alcaldía de Popayán.",
            imagen_url: "img/2017/Relatos de Matilda.webp"
        },
        {
            titulo: "El negro cirilo",
            grupo_artista: "Fundación La Tortuga Triste (Colombia)",
            descripcion: "Cuenta  las aventuras que sufre el personaje del mismo nombre cuando se entera que una bruja ha realizado un encantamiento y a enviado a su novia Yoly a un bosque de la china, tendrá entonces Cirilo que atravesar los terrenos de la serpiente de tierra caliente, de la iguana que toma café, viajará acompañado de su amigo el caimán que nada en el río Paraná, aunque él va para Barranquilla, tendrá que resolver como llegar  hasta la China para poder rescatar a Yoly Romper el encantamiento no será fácil pero los niños le ayudarán en esta ardua tarea.",
            imagen_url: "img/2017/El negro cirilo.webp"
        },
        {
            titulo: "Los Mundos de Fingerman",
            grupo_artista: "(Peru)",
            descripcion: "Es la historia de los viajes de Fingerman a través de los cuatro mundos: aire, agua, fuego y su final llegada a la tierra.<br/>En la primera historia, el mundo del AIRE, él nace en un mundo perfecto, libre, con posibilidades infinitas, donde sus creadores están al servicio de sus deseos.En esta historia se transforma en pájaro, imitando a sus creadores.<br/>En la segunda historia, el mundo del AGUA, en la agitación y profundidades del océano emocional, quiere recuperar la nave naufragada que le fue dada para poder explorarlo.< br /> En la tercera historia, el mundo del FUEGO, experimenta la fuerza y dicha del poder creador que teje los destinos de la humanidad y se descubre a sí mismo como el tejedor de su propio destino.< br /> Finalmente, en la cuarta historia, el mundo de la TIERRA, llega al mundo de las consecuencias lugar de la conquista del conocimiento.Fingerman con el trabajo, crea su reino e intenta hacerlo a la imagen del mundo perfecto en el cual fue concebido.",
            imagen_url: "img/2017/Los Mundos de Fingerman.webp"
        }
        /*{
            titulo: "",
            grupo_artista: "",
            descripcion: "",
            imagen_url: ""
        }*/
    ]
};

function mostrarHistorico(year, button = null) {
    const container = document.getElementById("historyShowsContainer");
    if (!container) return;

    // Actualizar clase activa del botón si se proporciona
    if (button) {
        const buttons = document.querySelectorAll(".btn-history-year");
        buttons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");
    }

    const shows = HISTORIAL_EDICIONES[year] || [];

    // Transición suave: bajar opacidad, recargar y subir
    container.style.opacity = "0";

    setTimeout(() => {
        if (shows.length === 0) {
            container.innerHTML = `<p style="text-align: center; color: var(--text-muted); padding: 2rem 0;">No se encontraron registros para la edición del año ${year}.</p>`;
        } else {
            let cardsHTML = `<div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 1.5rem;">`;
            shows.forEach(show => {
                // Generar descripción corta y larga si excede 180 caracteres
                const descPlain = show.descripcion.replace(/<[^>]*>/g, ' '); // Strip HTML tags for clean counting
                let descHTML = '';

                if (descPlain.length > 180) {
                    const cutIndex = descPlain.indexOf(' ', 170); // Find word boundary
                    const actualCut = cutIndex !== -1 && cutIndex < 220 ? cutIndex : 180;
                    const shortText = descPlain.substring(0, actualCut) + '...';

                    descHTML = `
                        <span class="desc-short">${shortText}</span>
                        <span class="desc-full" style="display: none;">${show.descripcion}</span>
                        <a href="#" class="read-more-btn" onclick="toggleReadMore(event, this)" style="color: var(--accent-gold); font-size: 0.8rem; margin-top: 0.5rem; display: inline-block; font-weight: bold; text-decoration: none;"><i class="fa-solid fa-plus-circle"></i> Leer más</a>
                    `;
                } else {
                    descHTML = `<span>${show.descripcion}</span>`;
                }
                cardsHTML += `
                    <div class="history-show-card" style="opacity: 1; transition: opacity 0.3s ease;">
                        <img src="${show.imagen_url}" alt="${show.titulo}" onerror="this.style.display='none'" style="width:100%; height: 160px; object-fit: cover;">
                        <div style="padding: 1.2rem; display: flex; flex-direction: column; flex: 1;">
                            <h4 style="color: var(--accent-gold); font-size: 1.1rem; margin-bottom: 0.5rem;">${show.titulo}</h4>
                            <span style="font-size: 0.85rem; color: var(--text-light); margin-bottom: 0.8rem;"><i class="fa-solid fa-people-group"></i> ${show.grupo_artista}</span>
                            <p style="font-size: 0.85rem; color: var(--text-muted); line-height: 1.5; flex: 1;">${descHTML}</p>
                        </div>
                    </div>
                `;
            });
            cardsHTML += `</div>`;
            container.innerHTML = cardsHTML;
        }
        container.style.opacity = "1";
    }, 150);
}

function toggleReadMore(event, btn) {
    event.preventDefault();
    const parent = btn.parentElement;
    const shortSpan = parent.querySelector('.desc-short');
    const fullSpan = parent.querySelector('.desc-full');

    if (fullSpan.style.display === 'none') {
        fullSpan.style.display = 'inline';
        shortSpan.style.display = 'none';
        btn.innerHTML = '<i class="fa-solid fa-minus-circle"></i> Leer menos';
    } else {
        fullSpan.style.display = 'none';
        shortSpan.style.display = 'inline';
        btn.innerHTML = '<i class="fa-solid fa-plus-circle"></i> Leer más';
    }
}

async function enviarFormularioContacto(event) {
    event.preventDefault();
    const btn = event.target.querySelector('button[type="submit"]');
    const originalText = btn.innerHTML;

    // Cambiar estado a cargando
    btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Enviando...';
    btn.disabled = true;

    const payload = {
        action: 'contact',
        name: document.getElementById("contactName").value.trim(),
        email: document.getElementById("contactEmail").value.trim(),
        message: document.getElementById("contactMessage").value.trim()
    };

    try {
        const response = await fetch('api/contact.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const result = await response.json();

        alert(result.message);
        if (result.success) {
            event.target.reset();
        }
    } catch (e) {
        console.error(e);
        alert('Hubo un error al enviar el mensaje. Por favor, inténtalo más tarde.');
    } finally {
        btn.innerHTML = originalText;
        btn.disabled = false;
    }
}

async function enviarFormularioNewsletter(event) {
    event.preventDefault();
    const emailInput = event.target.querySelector('input[type="email"]');
    const btn = event.target.querySelector('button[type="submit"]');
    const originalText = btn.innerHTML;

    btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
    btn.disabled = true;

    const payload = {
        action: 'newsletter',
        email: emailInput.value.trim()
    };

    try {
        const response = await fetch('api/contact.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const result = await response.json();

        alert(result.message);
        if (result.success) {
            event.target.reset();
        }
    } catch (e) {
        console.error(e);
        alert('Hubo un error al registrarte. Por favor, inténtalo más tarde.');
    } finally {
        btn.innerHTML = originalText;
        btn.disabled = false;
    }
}

// 9. Carrusel Interactivo de Patrocinadores y Aliados
function initSponsorsCarousel() {
    const track = document.getElementById("sponsorsTrack");
    const prevBtn = document.getElementById("sponsorPrevBtn");
    const nextBtn = document.getElementById("sponsorNextBtn");
    const dotsContainer = document.getElementById("sponsorsDots");
    const wrapper = document.getElementById("sponsorsCarouselWrapper");

    if (!track || !prevBtn || !nextBtn) return;

    const cards = track.querySelectorAll(".sponsor-card");
    const totalCards = cards.length;
    let currentIndex = 0;
    let autoplayTimer = null;

    function getVisibleCards() {
        if (window.innerWidth <= 480) return 1;
        if (window.innerWidth <= 768) return 2;
        if (window.innerWidth <= 1024) return 3;
        return 4;
    }

    function getMaxIndex() {
        const visible = getVisibleCards();
        return Math.max(0, totalCards - visible);
    }

    function updateCarousel() {
        const visible = getVisibleCards();
        const maxIndex = getMaxIndex();
        if (currentIndex > maxIndex) currentIndex = maxIndex;
        if (currentIndex < 0) currentIndex = 0;

        const cardWidthPercent = 100 / visible;
        const offset = currentIndex * cardWidthPercent;

        track.style.transform = `translateX(-${offset}%)`;

        renderDots();
    }

    function renderDots() {
        if (!dotsContainer) return;
        const maxIndex = getMaxIndex();
        const numPages = maxIndex + 1;

        dotsContainer.innerHTML = '';
        for (let i = 0; i < numPages; i++) {
            const dot = document.createElement("button");
            dot.className = `sponsor-dot ${i === currentIndex ? 'active' : ''}`;
            dot.setAttribute("aria-label", `Ir a grupo ${i + 1}`);
            dot.addEventListener("click", () => {
                currentIndex = i;
                updateCarousel();
                restartAutoplay();
            });
            dotsContainer.appendChild(dot);
        }
    }

    function nextSlide() {
        const maxIndex = getMaxIndex();
        if (currentIndex >= maxIndex) {
            currentIndex = 0;
        } else {
            currentIndex++;
        }
        updateCarousel();
    }

    function prevSlide() {
        const maxIndex = getMaxIndex();
        if (currentIndex <= 0) {
            currentIndex = maxIndex;
        } else {
            currentIndex--;
        }
        updateCarousel();
    }

    function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, 3500);
    }

    function stopAutoplay() {
        if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    }

    function restartAutoplay() {
        startAutoplay();
    }

    prevBtn.addEventListener("click", () => {
        prevSlide();
        restartAutoplay();
    });

    nextBtn.addEventListener("click", () => {
        nextSlide();
        restartAutoplay();
    });

    if (wrapper) {
        wrapper.addEventListener("mouseenter", stopAutoplay);
        wrapper.addEventListener("mouseleave", startAutoplay);
        wrapper.addEventListener("touchstart", stopAutoplay, { passive: true });
        wrapper.addEventListener("touchend", startAutoplay, { passive: true });
    }

    // Soporte para gestos táctiles (Touch Swipe)
    let startX = 0;
    let endX = 0;

    track.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener("touchend", (e) => {
        endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        if (Math.abs(diffX) > 40) {
            if (diffX > 0) nextSlide();
            else prevSlide();
            restartAutoplay();
        }
    }, { passive: true });

    window.addEventListener("resize", () => {
        updateCarousel();
    });

    updateCarousel();
    startAutoplay();
}
